import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function Whatsapp({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.241 6.215a8.133 8.133 0 0 1 5.776-2.397c2.256 0 4.296.915 5.776 2.397A8.16 8.16 0 0 1 20.184 12a8.16 8.16 0 0 1-2.392 5.785 8.133 8.133 0 0 1-5.776 2.397 8.115 8.115 0 0 1-4.711-1.497l-.376-.266-2.06.688.69-2.075-.26-.374A8.148 8.148 0 0 1 3.85 12 8.16 8.16 0 0 1 6.24 6.215ZM12.017 2a9.946 9.946 0 0 0-7.06 2.929A9.98 9.98 0 0 0 2.035 12c0 1.949.557 3.77 1.52 5.308L2 21.98l4.645-1.55A9.927 9.927 0 0 0 12.017 22a9.947 9.947 0 0 0 7.059-2.929A9.98 9.98 0 0 0 22 12a9.98 9.98 0 0 0-2.924-7.071A9.946 9.946 0 0 0 12.016 2ZM8.339 12.308C6.88 10.128 6.9 8.412 8.4 7.16c.573-.073.944-.076 1.114-.009.115.03.198.107.249.233.393 1.119.645 1.8.753 2.044.095.231.072.436-.069.615l-.683.839a.602.602 0 0 0-.01.281c1.517 2.64 3.551 3.143 3.551 3.143l.227-.078c.461-.606.75-.971.866-1.096.116-.125.258-.16.428-.106l2.197 1.14c.173 1.146-.388 1.936-1.684 2.37-1.328.165-2.222-.255-2.903-.574-.128-.06-.249-.117-.363-.166a6.776 6.776 0 0 0-.248-.15c-.624-.366-1.757-1.03-3.486-3.338Z"
                fill={color}
            />
        </svg>
    );
}

export default Whatsapp;
